<!-- Mobile menu overlay -->
<div
  *ngIf="mobileMenuOpen"
  class="fixed inset-0 bg-black/60 z-40"
  (click)="mobileMenuOpen = false"
></div>

<!-- Mobile drawer -->
<div
  class="fixed top-0 start-0 h-screen w-72 bg-[#061430] z-50 transform transition-transform duration-300 overflow-y-auto"
  [class.translate-x-0]="mobileMenuOpen"
  [class.ltr:-translate-x-full]="!mobileMenuOpen"
  [class.rtl:translate-x-full]="!mobileMenuOpen"
>
  <div class="flex justify-end p-4">
    <button (click)="mobileMenuOpen = false" class="text-white">
      <svg
        class="w-6 h-6"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        stroke-width="2"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          d="M6 18L18 6M6 6l12 12"
        />
      </svg>
    </button>
  </div>
  <div class="px-6 pb-12 flex flex-col gap-2">
    <a routerLink="/talent-search" class="mb-6">
      <img
        src="assets/images/logo_white.svg"
        alt="Uptal"
        class="h-10 select-none pointer-events-none"
        draggable="false"
      />
    </a>
    <a
      *ngFor="let link of navLinks"
      routerLink="/talent-search"
      [fragment]="link.fragment"
      (click)="mobileMenuOpen = false"
      class="py-3 text-white text-base font-medium border-b border-white/10"
    >
      {{ link.label | translate }}
    </a>
    <a [href]="loginUrl" class="mt-4 py-3 text-white text-base font-medium">
      {{ "talentSearchV2.header.login" | translate }}
    </a>
    <a
      routerLink="/talent-search"
      fragment="pricing"
      (click)="mobileMenuOpen = false"
      class="mt-2 flex items-center justify-center gap-2 rounded-lg bg-[#353CD8] py-3 px-6 text-white text-base font-bold"
    >
      {{ "talentSearchV2.header.startNow" | translate }}
    </a>
  </div>
</div>

<!-- Desktop header bar -->
<nav class="w-full border-b border-[rgba(6,20,48,0.09)] bg-white">
  <div
    class="flex items-center justify-between max-w-[1200px] mx-auto px-6 md:px-12 py-3"
  >
    <!-- Logo -->
    <a routerLink="/talent-search" class="shrink-0">
      <img
        src="assets/images/logo_wide_sm.webp"
        alt="Uptal"
        class="h-8 w-auto select-none pointer-events-none"
        draggable="false"
      />
    </a>

    <!-- Desktop nav links -->
    <ul class="hidden lg:flex items-center gap-8">
      <li *ngFor="let link of navLinks">
        <a
          routerLink="/talent-search"
          [fragment]="link.fragment"
          class="text-[14px] font-medium text-[#3B4A6B] hover:text-[#061430] transition-colors"
        >
          {{ link.label | translate }}
        </a>
      </li>
      <li class="!text-sm">
        <select-language
          className="text-sm text-[#3B4A6B]"
          color=""
          iconClassName="w-4 h-4 text-base"
          [allowedLocales]="['en', 'ar']"
        />
      </li>
    </ul>

    <!-- Built in KSA badge -->
    <span
      class="rounded-full hidden lg:inline-flex items-center gap-1.5 border bg-white px-3 py-1.5 text-[12px] font-semibold text-[#061430]"
    >
      <app-icon name="svg:sa-flag" [size]="16" />
      {{ "talentSearchV2.header.builtInKSA" | translate }}
    </span>

    <!-- Mobile language picker -->
    <select-language
      class="lg:hidden ms-auto me-2"
      className="text-sm text-[#3B4A6B]"
      iconClassName="hidden"
      color=""
      [fullSize]="false"
      [allowedLocales]="['en', 'ar']"
    />

    <!-- Right side -->
    <div class="hidden lg:flex items-center gap-3">
      <!-- Login -->
      <a
        [href]="loginUrl"
        class="inline-flex items-center rounded-full border border-[rgba(6,20,48,0.15)] px-5 py-2 text-[14px] font-medium text-[#061430] hover:bg-slate-50 transition-colors"
      >
        {{ "talentSearchV2.header.login" | translate }}
      </a>

      <!-- Start now -->
      <a
        routerLink="/talent-search"
        fragment="pricing"
        class="inline-flex items-center gap-1.5 rounded-full bg-[#353CD8] px-5 py-2 text-[14px] font-bold text-white shadow-[0_4px_16px_0_rgba(53,60,216,0.3)] hover:bg-[#2930b8] transition-colors"
      >
        {{ "talentSearchV2.header.startNow" | translate }}
        <span class="inline-grid place-items-center rtl:flip"><app-icon name="tabler:arrow-narrow-right" [size]="18" /></span>
      </a>
    </div>

    <!-- Mobile hamburger -->
    <button class="lg:hidden p-1" (click)="mobileMenuOpen = true">
      <svg
        class="w-6 h-6 text-[#061430]"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        stroke-width="2"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          d="M4 6h16M4 12h16M4 18h16"
        />
      </svg>
    </button>
  </div>
</nav>
